  const deleteHeadHunters = async ({
    worldContract,
    smartObjectId,
    smartCharacterIds,
  }: {
    worldContract: any;
    smartObjectId: string;
    smartCharacterIds?: string[];
  }): Promise<string | undefined> => {
    let txHash;
  
    txHash = await worldContract.write.Tapticc__deleteHeadHunters([smartObjectId, smartCharacterIds]);

    return txHash;
  };
  
  export default deleteHeadHunters;
  